type SuccessResponse = { data: Record<string, any> };
type ErrorResponse = { error: Record<string, any> };

const checkIfServerError = <Success extends SuccessResponse, Error extends ErrorResponse>(
  response: Success | Error
): response is Error => {
  return Boolean((response as Error).error?.code);
};

const extractError = <Success extends SuccessResponse, Error extends ErrorResponse>(
  response: Success | Error
) => {
  if (checkIfServerError<Success, Error>(response)) {
    throw response.error;
  }

  return response.data;
};

export default extractError;
